// extracted by mini-css-extract-plugin
module.exports = {"gallery":"gallery--gallery--1wROW","gallery__wrapper":"gallery--gallery__wrapper--2oq7y","img":"gallery--img--13K2a"};